import React from "react"
import loadingIcon from "../../assets/icons/loading.gif"

export default function Loading() {
  return (
    <div className="loading">
      <div className="text-center ">
        <img src={loadingIcon} alt="loading-icon" />
        <code className="green-code">Loading...</code>
      </div>
    </div>
  )
}
